import React, { useState, useEffect } from 'react';
import {
  Table,
  notification,
  Popconfirm,
  Space,
  Typography,
  Layout,
} from 'antd';
import { Link } from 'react-router-dom';

import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import CustomButton from '../../../components/CustomButton';
import SpinLoad from '../../../components/SpinLoad';
import PdfViewer from '../../../components/PdfViewer';

import { filter, remove } from '../../../api/module/resume_experience_icfes';
import { get as getDocumentUrl } from '../../../api/module/document_repository';
import { catchException } from '../../../utils/helpers/helpers';

const { Paragraph } = Typography;
const { Content } = Layout;

const ExperiencieIcfesList = ({ idTercero, readOnly = false }) => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const showClick = async (documento_nombre) => {
    setLoadingDocument(true);

    const response = await getDocumentUrl(documento_nombre);

    setPdfUrl(response.data.url);
    setShowPdf(true);
    setLoadingDocument(false);
  };

  useEffect(() => {
    if (idTercero !== undefined) getDataSource();
  }, []);

  const getDataSource = async () => {
    try {
      setLoading(true);
      const response = await filter('?filter[tercero]=' + idTercero);
      setDataSource(response.data.results);
      setLoading(false);
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  const deleteDataSource = async (id) => {
    try {
      setLoadingDelete(true);
      const response = await remove(id);
      setLoadingDelete(false);
      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
          duration: 2,
        });
        await getDataSource();
      }
    } catch (err) {
      console.log(err);
      setLoadingDelete(false);
      catchException(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };
  const columns = [
    {
      title: 'Prueba-proceso',
      dataIndex: 'proceso_icfes_nombre',
      key: 'proceso_icfes_nombre',
    },
    {
      title: 'Rol/Cargo desempeñado',
      dataIndex: 'rol_icfes_nombre',
      key: 'rol_icfes_nombre',
    },
    {
      title: 'Año participación',
      dataIndex: 'anyo',
      key: 'anyo',
    },
    {
      title: 'Semestre participación',
      dataIndex: 'semestre',
      key: 'semestre',
    },
    {
      title: 'Consultar documento',
      dataIndex: 'tarjeta_profesional',
      key: 'tarjeta_profesional',
      fixed: 'right',
      width: 120,
      render: (text, record) => {
        if (record.documento_nombre) {
          return (
            <CustomButton
              block
              type="default"
              htmlType="button"
              text="Ver"
              loading={loadingDocument}
              onClick={() => {
                showClick(record.documento_nombre);
              }}
            />
          );
        }
      },
    },
    {
      title: 'Acción',
      key: 'accion',
      fixed: 'right',
      width: 200,
      render: (_, record) =>
        dataSource.length >= 1 && !readOnly ? (
          <Space>
            <CustomButton
              type={'default'}
              className={'ant-btn-info'}
              htmlType="button"
              text={
                <Link
                  to={`${INTERNAL_LINKS.EXPERIENCIE_ICFES}/${idTercero}/${record.id}`}
                >
                  Editar
                </Link>
              }
            />
            <CustomButton
              danger
              type={'default'}
              htmlType="button"
              loading={loadingDelete}
              text={
                <Popconfirm
                  title={MESSAGES.DELETE_CONFIRM_MSG}
                  onConfirm={() => deleteDataSource(record.id)}
                >
                  Eliminar
                </Popconfirm>
              }
            />
          </Space>
        ) : null,
    },
  ];

  return (
    <Content>
      <SpinLoad loading={loading}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={dataSource}
          scroll={{ x: 1100 }}
          title={() => (
            <Paragraph className={'margin-5'} strong>
              Listado de Experiencia ICFES
            </Paragraph>
          )}
        />
      </SpinLoad>
      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setShowPdf(false)}
        open={showPdf}
      />
    </Content>
  );
};

export default ExperiencieIcfesList;
